import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import './assets/css/global.css'
import axios from 'axios'

Vue.config.productionTip = false

// 使用ElementUI
Vue.use(ElementUI, { size: 'medium' })

// 配置axios
axios.defaults.baseURL = 'https://api.slumberland.cn'
Vue.prototype.$http = axios

// 请求拦截器
axios.interceptors.request.use(config => {
  // 从localStorage中获取token
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(response => {
  return response
}, error => {
  // 处理401未授权错误
  if (error.response && error.response.status === 401) {
    // 清除token并跳转到登录页
    localStorage.removeItem('token')
    router.push('/login')
  }
  return Promise.reject(error)
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
